export function getCorp(data) {
    let { getCorpRequest, getCorpError, getCorpResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/corp/get',
        this.createBundle('app/corp/get', { id: data }, this.GET, getCorpRequest, getCorpResult, getCorpError)
    )
}
